import { render } from "./StudySpaceView.vue?vue&type=template&id=8eab1504"
import script from "./StudySpaceView.vue?vue&type=script&lang=js"
export * from "./StudySpaceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__